module.exports = __webpack_public_path__ + "en/static/img/logo1.bbb4318.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo1.png
// module id = wx7f
// module chunks = 1